export const localizations = {
    username: "Username",
    password: "Password",
    name: "Name",
    description: "Description",
    room_rack: "Room/Rack",
    switch_port: "Switch/Port",
    management_ip: "Network control IP",
    management_ip_ssl: "HTTPS/SSL",
    device: "Device type",
    device_type: "Device type",
    site: "Site",
    site_name: "Site",
    unit: "UE",
    codec: "Type",
    ip: "Network stream IP",
    did: "PSTN Number",
    replace_caller_id: "Replace Caller ID",
    replace_id: "Replace ID",
    supported_algorithms: "Supp. algorithms"
}

export const codecTypes = [
    { key: 0, name: "Reserve" },
    { key: 1, name: "Fix" },
    { key: 2, name: "Mobile" },
    { key: 3, name: "Correspondent" },
    { key: 4, name: "LargeOperations" },
    { key: 9, name: "Test" }
]


// WEBPACK FOOTER //
// ./config.js